import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { Button } from './Button';
export function Header() {
  return <header className="bg-white border-b border-slate-200 sticky top-0 z-50" data-id="element-85">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-86">
        <div className="flex items-center justify-between h-20" data-id="element-87">
          {/* Logo */}
          <Link to="/" data-id="element-88">
            <Logo data-id="element-89" />
          </Link>

          {/* Navigation */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-90">
            <Link to="/" className="text-slate-700 hover:text-emerald-600 font-medium transition-colors" data-id="element-91">
              Home
            </Link>
            <Link to="/service-details" className="text-slate-700 hover:text-emerald-600 font-medium transition-colors" data-id="element-92">
              Service Details
            </Link>
            <Link to="/about" className="text-slate-700 hover:text-emerald-600 font-medium transition-colors" data-id="element-93">
              About
            </Link>
            <Link to="/faqs" className="text-slate-700 hover:text-emerald-600 font-medium transition-colors" data-id="element-94">
              FAQs
            </Link>
            <Link to="/contact" className="text-slate-700 hover:text-emerald-600 font-medium transition-colors" data-id="element-95">
              Contact
            </Link>
          </nav>

          {/* CTA Button */}
          <Link to="/contact" data-id="element-96">
            <Button variant="primary" size="md" data-id="element-97">
              Contact Us
            </Button>
          </Link>
        </div>
      </div>
    </header>;
}